export default {
      id: "xtype_xtag-usage",
      viewBox: "0 0 26 14",
      url: __webpack_public_path__ + "img/icons.svg#xtype_xtag",
      toString: function () {
        return this.url;
      }
    }